// base64 ⇄ バイト列。MCP ブリッジがローカルのファイルを読んでタブへ渡すときに使う。

/** 受け取ってよい base64 の上限 (約 48 MiB のファイル) */
export const MAX_BASE64_LENGTH = 64 * 1024 * 1024

export class DataTooLargeError extends Error {}

/** data: URL の接頭辞と空白を許容して base64 を復号する */
export function base64ToBytes(b64: string): Uint8Array<ArrayBuffer> {
  const body = b64.startsWith('data:') ? b64.slice(b64.indexOf(',') + 1) : b64
  const clean = body.replace(/\s+/g, '')
  if (clean.length > MAX_BASE64_LENGTH) throw new DataTooLargeError(`データが大きすぎます (${Math.round(clean.length / 1048576)} MB、上限 ${MAX_BASE64_LENGTH / 1048576} MB)`)
  const bin = atob(clean)
  const out = new Uint8Array(bin.length)
  for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i)
  return out
}

export function bytesToBase64(bytes: Uint8Array): string {
  let s = ''
  // 引数の個数制限を避けて 32KB ずつ
  for (let i = 0; i < bytes.length; i += 0x8000) s += String.fromCharCode(...bytes.subarray(i, i + 0x8000))
  return btoa(s)
}
